import CrudRepository from './CrudRepository'
export default class ConsumptionRepository extends CrudRepository {
  constructor () {
    super('core/api/bundles/overview')
  }
}
